export enum CertificateStatusEnum {
  VALID = 'VALID',
  DUE_TO_EXPIRE = 'DUE_TO_EXPIRE',
  EXPIRED = 'EXPIRED',
  INVALID = 'INVALID',
  NOT_ACTIVE = 'NOT_ACTIVE',
}

export interface CertificateInfo {
  id: string
  status: CertificateStatusEnum
  name: string
  subject: string
  issuer: string
  validFrom: string
  validTo: string
  fingerprint: string
}
